




import AbpBase from "../../../lib/abpbase";
import * as echarts from "echarts";
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
@Component
export default class echart extends AbpBase {
  //饼图
  Pieoption = {
    tooltip: {
      trigger: "item",
    },
    legend: {
      bottom: "-5px",
    },
    series: [
      {
        name: "数量",
      type: 'pie',
      radius: ['40%', '65%'],
      avoidLabelOverlap: false,
      labelLine: {
        show: false
      },
      label:{
        show:false
      },
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: "rgba(0, 0, 0, 0.5)",
          },
        },
      },
    ],
  };
  myPieChart; //饼图
  chart() {
    //饼图
    this.myPieChart = echarts.init(document.getElementById("Piechart"));
    this.myPieChart.setOption(this.Pieoption);
  }
  //加载饼图数据
  async PieGet() {
    let list = await this.$store.dispatch({
      type: "thequipment/getCountHomeEchart",
    });
    let res = [];
    for (var i = 0; i < list.length; i++) {
      res.push({ name: list[i].fname, value: list[i].zCount });
    }
    this.myPieChart.setOption({
      series: [
        {
          data: res,
        },
      ],
    });
  }
  created() {
    this.PieGet();
  }
  mounted() {
    this.chart();
  }
}
